import call from './httpClient';

const BASE_URL = `${import.meta.env.VITE_APP_API_URL}/v1/payments`;

export const GetReceipt = async (id) => call({
  method: 'GET',
  url: `${BASE_URL}/${id}/receipt`,
});

export const DownloadReceipt = async (url) => call({
  data: {
    url,
  },
  responseType: 'blob',
  method: 'POST',
  url: import.meta.env.VITE_APP_INVOICE_API_URL,
});
